import type { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useClientApproval } from './hooks/useClientApproval';
import { ClientApprovalForm } from './components/ClientApprovalForm';
import { ClientApprovalResult } from './components/ClientApprovalResult';

export const ClientApprovalPage: FC = () => {
    const { token } = useParams<{ token: string }>();
    const controller = useClientApproval(token);

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
                {controller.state === 'pending' && controller.data ? (
                    <ClientApprovalForm data={controller.data} controller={controller} />
                ) : (
                    <ClientApprovalResult state={controller.state} approvedAt={controller.data?.approvedAt} />
                )}
            </div>
        </div>
    );
};
